import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, TemplateRef } from '@angular/core';
import { TooltipBase, TooltipPlacement } from '@celerofinancas/ui-directives';

/**
 * Tooltip component for displaying additional information on hover or focus.
 */
@Component({
  selector: 'caixa-webcomponent-tooltip',
  standalone: true,
  templateUrl: './tooltip.component.html',
  styleUrl: './tooltip.component.scss',
  imports: [NgTemplateOutlet],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TooltipComponent implements TooltipBase {
  /**
   * Tooltip custom template
   */
  @Input()
  public tooltipRef: TemplateRef<any>;

  /**
   * Tooltip text
   */
  @Input()
  public text = '';

  /**
   * Tooltip text
   */
  @Input()
  public maxWidth: string | number;

  /**
   * Tooltip placement
   */
  @Input()
  public placement?: TooltipPlacement = 'top';
}
